export default () => ({
    open: false,
    cookieName: 'a11yCookieConsent',
    cookieTimeout: 31104000000, // 12 months
    bots: /bot|crawler|spider|crawling/i,
    init() {
        const isDisabled = new URLSearchParams(window.location.search).has('a11yCookieConsentDisabled');
        const isBot = this.bots.test(navigator.userAgent);
        const dnt = navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack;
        const isToTrack = (dnt !== null && dnt !== undefined) ? (dnt && dnt !== 'yes' && dnt !== 1 && dnt !== '1') : true;

        if (isDisabled || isBot || !isToTrack || this.isCookieSetTo('denied')) {
            // console.debug('Tracking cookie disabled.')
            return;
        }
        if (this.isCookieSetTo('accepted')) {
            const _paq = window._paq = window._paq || [];
            _paq.push(['setCookieConsentGiven']);
            // console.debug('Tracking cookie enabled.')
        }
        else {
            this.open = true;
            this.$refs.acceptButton.focus();
        }
    },
    accept() {
        if (! this.open) return;
        this.open = false;
        this.setCookie(this.cookieName, 'accepted');
    },
    decline() {
        if (! this.open) return;
        this.open = false;
        this.setCookie(this.cookieName, 'denied');
    },
    isCookieSetTo(value) {
        return document.cookie.indexOf(this.cookieName + '=' + value) > -1;
    },
    setCookie(name, value) {
        const date = new Date();
        date.setTime(date.getTime() + this.cookieTimeout);
        document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/' + ';secure;SameSite=Lax';
    },
    initLinks(rteElement) {
        const rteLinks = rteElement.getElementsByTagName('a');
        for (const link of rteLinks) {
            link.href += link.href.indexOf('?') === -1 ?  "?a11yCookieConsentDisabled" : "&a11yCookieConsentDisabled";
        }
    }
})
